  document.addEventListener('DOMContentLoaded', function() {
    const statCards = document.querySelectorAll('.swiss-stat-card');
    statCards.forEach((card, index) => {
      setTimeout(() => {
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      }, 100 * index);
    });
    const statNumbers = document.querySelectorAll('.swiss-stat-number');
    
    statNumbers.forEach(number => {
      const targetValue = parseInt(number.textContent.replace(/[^\d]/g, ''));
      const plus = number.querySelector('.swiss-stat-plus');
      const suffix = plus ? plus.outerHTML : '';
      number.setAttribute('data-target', targetValue);
      if (targetValue !== 2022) {
        number.textContent = '0';
        if (plus) number.appendChild(plus);
      }
    });
    
    // Create intersection observer for scroll animation
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const number = entry.target.querySelector('.swiss-stat-number');
          const targetValue = number.getAttribute('data-target');
          
          if (targetValue !== '2022') { 
            let currentValue = 0;
            const plus = number.querySelector('.swiss-stat-plus');
            const duration = 2000;
            const step = targetValue / (duration / 16);
            const counter = setInterval(() => {
              currentValue += step;
              if (currentValue >= targetValue) {
                currentValue = targetValue;
                clearInterval(counter);
              }
              number.textContent = Math.floor(currentValue);
              if (plus) number.appendChild(plus);
            }, 16);
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    statCards.forEach(card => {
      observer.observe(card);
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    });
  });